<template>
  <div class="pub-page">
    <div class="pub-header d-flex align-items-center justify-content-between">
      <div>
        <text class="title me-1">{{$route.meta.title}}</text>
        <el-input clearable style="width: 200px;" placeholder="请输入学校名称"
                  v-model="params.name"
                  @clear="reset"
                  @change="getList(true)"
                  class="me-1"></el-input>
        <el-button type="primary"  @click="getList(true)">搜索</el-button>
        <el-button type=""  @click="reset">重置</el-button>
      </div>

      <el-button type="primary"  class="ms-2 me-3" @click="handleAdd" v-if="isSupperAdmin">添加学校</el-button>
    </div>
    <div class="pub-center">
      <el-table scrollbar-always-on border   :data="list" style="width: calc(100% - 30px);position: absolute;left: 15px;top:10px;padding-bottom: 30px"  v-loading="loading">
        <el-table-column label="省份"  min-width="150px" show-overflow-tooltip >
          <template #default="scope">
            {{scope.row.Province || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="学校名称" min-width="250px" show-overflow-tooltip >
          <template #default="scope">
            {{scope.row.Name || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="学校标识" min-width="150px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Code || '-'}}
          </template>
        </el-table-column>
        <el-table-column label="主管部门" min-width="120px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Department || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="学校标签" min-width="200px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Tags || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="所在地" min-width="120px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.City || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="办学层次" min-width="120px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Level || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="国家" min-width="120px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.Country || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="创建时间" min-width="170px" show-overflow-tooltip>
          <template #default="scope">
            {{scope.row.CreatedTime || "-"}}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200px" fixed="right" v-if="isSupperAdmin">
          <template #default="scope">
            <el-button  size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button  size="small"    type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pub-footer d-flex align-items-center justify-content-center">
      <el-pagination  v-show="total>0" background
                      layout="total, sizes, prev, pager, next"
                      :page-sizes="[10, 20, 30, 40]"
                      :total="total"
                      v-model:current-page="params.current"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"/>
    </div>

    <AddSchoolModel :item="choisedItem" @close="closeInfoChange" v-if="dialogVisible" @success="updateInfoChange"></AddSchoolModel>
  </div>
</template>

<script setup>
import {computed, onMounted, reactive, ref} from "vue";
import AddSchoolModel from "@/components/AddSchoolModel"
import {ElMessage,ElMessageBox} from "element-plus";
const dialogVisible = ref(false)
const choisedItem = ref()
import {formatTime} from "@/utils/dateFun";
import {getUniversitys, removeUniversity} from "@/api/schoolAdmin";
import {needInitQueryFun} from "@/utils/common";
import {useStore} from 'vuex'
const store = useStore()
const isSupperAdmin =  computed(()=>store.state.loginModel.isSupperAdmin)
const params = reactive({
  pageSize:10,
  current:1,
  name:null
})
const total = ref(0)
const list = ref([])
const loading = ref(false)
onMounted(()=>{
  getList()
})
const reset = ()=>{
  params.name = ""
  getList(true)
}
// 列表
const getList = async (init)=>{
  if(init){
    params.current = 1
  }
  loading.value = true
  const res = await getUniversitys(params)
  loading.value = false
  if(res.success){
    total.value = res.total
    let data = res.data || []
    data.forEach(item=>{
      //  创建时间
      if(item.CreatedAt){
        item.CreatedTime = formatTime(item.CreatedAt)
      }
    })
    list.value = data
  }else{
    return  ElMessage.warning("获取列表失败")
  }
}


// 添加
const handleAdd = ()=>{
  choisedItem.value = {}
  dialogVisible.value = true
}
// 编辑
const handleEdit = (index,item)=>{
  choisedItem.value = item
  dialogVisible.value = true
}
// 删除
const handleDelete = (number,item)=>{
  ElMessageBox.alert('确定要删除吗？', '删除', {
    confirmButtonText: '确定',
    callback: (action) => {
      if(action==='confirm'){ // 确定
        const needInitQuery = needInitQueryFun(total.value,params.pageSize,number)
        removeUniversity({ids:[item.ID]}).then(res=>{
          if(res.err_code === 0){
            ElMessage.success(`删除成功`)
            if(needInitQuery){
              getList(true) // 重新请求
            }else{
              getList() // 重新请求
            }
          }else{
            ElMessage.error(res.err_msg ||`删除失败,请稍后再试`)
          }
        })
      }
    },
  })
}

// 关闭信息修改
const closeInfoChange = ()=>{
  dialogVisible.value = false
}
// 新建或修改成功
const updateInfoChange = ()=>{
  dialogVisible.value = false
  reset()
}

// 页码改变
const handleSizeChange = (event) => {
  if(params.pageSize !==event){
    params.current = 1
    params.pageSize = event
    getList()
  }
}
const handleCurrentChange = ()=>{
  getList()
}
</script>

<style scoped lang="scss">


</style>
